import { useContext } from "react";

import { SxProps } from "@mui/material";
import { formatDateTimeToLocaleString, PaymentMethod } from "@simplyk/common";

import { FrontendFormContext } from "../../../../../contexts/FrontendFormContext";
import { FrontendTicketingContext } from "../../../../../contexts/FrontendTicketingContext";
import { useLocaleContext } from "../../../../../contexts/LocaleContext";

import { FormInfobox } from "@/forms-design-system/FormInfobox";
import { useTranslate } from "@/hooks/useTranslate";
import { Info } from "@/icons/outlined";

export const AuctionPaymentInfoBox = ({ sx }: { sx?: SxProps }) => {
  const { t } = useTranslate();
  const { locale } = useLocaleContext();
  const { selectedOccurrenceWithRates } = useContext(FrontendTicketingContext);
  const { selectedPaymentMethod } = useContext(FrontendFormContext);

  const selectedOccurrence = selectedOccurrenceWithRates?.occurrence;

  if (selectedPaymentMethod === PaymentMethod.Cash || !selectedOccurrence?.endUtc) {
    return null;
  }

  return (
    <FormInfobox
      variant="emphasis"
      icon={<Info />}
      title={t("ticketing", "auction.summary.chargeInfo.title")}
      description={t("ticketing", "auction.summary.chargeInfo.body", {
        date: formatDateTimeToLocaleString(selectedOccurrence?.endUtc, locale, {
          month: "long",
          day: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
      })}
      sx={sx}
    />
  );
};
